import type { TaskModel } from '../types/task.model';

export const taskStatusToColor = (task: TaskModel) => {
	switch (task.status) {
		case 'completed':
			return 'completed';
		case 'scheduled':
			return 'scheduled';
		case 'all_rejected':
		case 'overdue':
			return 'attention';
		default:
			return '';
	}
};
